import React from "react";

import AuthLayout from "../layouts/Auth";

import SignIn from "../pages/auth/sign-in";

function Presentation() {
  return (
    <React.Fragment>
      {/* <AppBar />
      <Introduction />
      <Demos />
      <Testimonial />
      <Integrations />
      <Features />
      <FAQ />
      <JoinUs /> */}

      <SignIn />
    </React.Fragment>
  );
}

Presentation.getLayout = function getLayout(page) {
  return <AuthLayout>{page}</AuthLayout>;
};

export default Presentation;
